<strong>fallback</strong>
<pre><code  [highlight]="displayModel | json"></code></pre>
